export const MedicalData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 2,
  leavecategoryid: 1,
  leavename: null,
  description: null,
  isallocatebalance: true,
  isautoallocation: false,
  monthlyallocate: [
    {
      monthid: 1,
      value: 0,
    },
    {
      monthid: 2,
      value: 0,
    },
    {
      monthid: 3,
      value: 0,
    },
    {
      monthid: 4,
      value: 0,
    },
    {
      monthid: 5,
      value: 0,
    },
    {
      monthid: 6,
      value: 0,
    },
    {
      monthid: 7,
      value: 0,
    },
    {
      monthid: 8,
      value: 0,
    },
    {
      monthid: 9,
      value: 0,
    },
    {
      monthid: 10,
      value: 0,
    },
    {
      monthid: 11,
      value: 0,
    },
    {
      monthid: 12,
      value: 0,
    },
  ],
  annualbalance: 0,
  genderids: null,
  employeetypeids: null,
  maritalstatusids: null,
  isprorate: true,
  proratetypeid: 1,
  creditmodetypeid: 1,
  midjoinstartday: 0,
  isextentionprobation: false,
  creditdaymonth: null,
  othercreditmodetypeid: 0,
  isaccrual: false,
  accuralfrequencytype: 0,
  isunusedforward: false,
  isprobationaccurallimit: false,
  probationaccurallimit: 0,
  unusedprobationleavbtypeid: 0,
  creditlimitinnonaccural: 0,
  isattachment: false,
  attachmentduration: 0,
  attachmentnote: null,
  maxleaveinprobation: 1,
  maxleave: 1,
  maxleavedurationtypeid: 0,
  maxconsecutiveleave: 1,
  maxconsecutiveleavedurationtypeid: 0,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 1,
  notifyinadvanceday: 1,
  notifynotbeforeday: 1,
  ispastappallowed: false,
  apppastday: 1,
  isleaveallowedinnotice: false,
  leavecountinnotice: 1,
  isintervinigallowed: false,
  interviningpolicy: {
    isinterviningholiday: false,
    holidayinterviningcount: 2,
    isholidayinterviningclubbed: false,
    isprefixholiday: false,
    holidayprefixcount: 0,
    issuffixholiday: false,
    holidaysuffixcount: 0,
    isinterviningoptholiday: false,
    optholidayinterviningcount: 0,
    isoptholidayinterviningclubbed: false,
    isprefixoptholiday: false,
    optholidayprefixcount: 0,
    issuffixoptholiday: false,
    optholidaysuffixcount: 0,
    isinterviningweeklyoff: false,
    weeklyoffinterviningcount: 0,
    isweeklyoffinterviningclubbed: false,
    isprefixweeklyoff: false,
    weeklyoffprefixcount: 0,
    issuffixweeklyoff: false,
    weeklyoffsuffixcount: 0,
  },
  isclubbingallowed: false,
  clubbingleaveid: null,
  isoverutilizationallowed: false,
  overutilizationpolicy: {
    excessleaveactiontypeid: 0,
    excesspaidlimit: 0,
    altleaveid: 0,
    altexcessleaveactiontypeid: 0,
    altleavetypeid: 0,
  },
  iscarryforwardallowed: false,
  carryforward: {
    iscarryforwardpolicy: false,
    carryforwardpolicy: {
      forwardtypeid: 0,
      carryforwardunusedperc: 0,
      carryforwardunused: 0,
      pendingactiontypeid: 0,
      remaningtypeid: 0,
      remaningperc: 0,
      noofremaning: 0,
      transferleaveid: 0,

    },
    encashmentpolicy: {
      encashmenttypeid: 0,
      encashmentunusedperc: 0,
      encashmentunused: 0,
      pendingactiontypeid: 0,
      remaningtypeid: 0,
      remaningperc: 0,
      noofremaning: 0,
      transferleaveid: 0,
    },
  },
  isgiftallowed: false,
  giftactiontypeid: 0,
  giftperc: 0,
  noofgift: 0,
  isgiftapproval: false,
  datastate: 1,
};
